import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import { XLSX, PDF } from 'assets/images';
import { DownloadOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { DATA_EXPORT_FILE_TYPE } from 'util/config/constant';

export const MachineDeletionModalContent = ({
  onChangeFileType,
  defaultFileType,
  className
}) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.MACHINE_DETAILS);
  const [fileType, setFileType] = useState(defaultFileType);

  useEffect(() => {
    if (defaultFileType) {
      setFileType(defaultFileType);
    }
  }, [defaultFileType]);

  const onClickFileType = useCallback(
    (newFileType) => {
      setFileType(newFileType);
      onChangeFileType(newFileType);
    },
    [onChangeFileType]
  );

  return (
    <div className={`machine-deletion-modal-content ${className}`}>
      <p>{t('deletionModal.description')}</p>
      <p className="description">
        <DownloadOutlined className="download-icon" />
        &nbsp; {t('deletionModal.hint')}
      </p>

      <div className="file-type-btn-wrapper">
        <Button
          type="link"
          className={`file-type-btn ${
            fileType === DATA_EXPORT_FILE_TYPE.XLSX && 'active'
          }`}
          onClick={() => onClickFileType(DATA_EXPORT_FILE_TYPE.XLSX)}>
          <XLSX />
        </Button>

        <Button
          className={`file-type-btn ${
            fileType === DATA_EXPORT_FILE_TYPE.PDF && 'active'
          }`}
          type="link"
          data-testid="file-pdf-button"
          onClick={() => onClickFileType(DATA_EXPORT_FILE_TYPE.PDF)}>
          <PDF />
        </Button>
      </div>
    </div>
  );
};

MachineDeletionModalContent.defaultProps = {
  defaultFileType: '',
  className: ''
};

MachineDeletionModalContent.propTypes = {
  onChangeFileType: PropTypes.func.isRequired,
  defaultFileType: PropTypes.string,
  className: PropTypes.string
};
